import React, { useEffect, useState } from 'react';
import { CardBody, Table } from "react-bootstrap";
import { useLocation } from 'react-router';
// import _axios from "axios";
import { ServerPath } from '../../../../Constant';
import './ActiveParikamiTable.css';
import { _axios } from '../../../../utils/axios';

function ActiveParikamiTableCardBody() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    const location = useLocation();
    const darkMode = new URLSearchParams(location.search).get('layout') === 'dark-only';
    
    useEffect(() => {
        const fetchActiveUsers = async () => {
            try {
                setLoading(true);
                const response = await _axios.get(`${ServerPath}/users/active-users`);
                console.log('Active users data:', response.data);
                
                if (response.data.success) {
                    setUsers(response.data.data || []);
                } else {
                    console.error("Failed to fetch users:", response.data.message);
                }
            } catch (error) {
                console.error("Error fetching active users:", error);
            } finally {
                setLoading(false);
            }
        };
        
        fetchActiveUsers();
    }, []);

    // Format the full name by combining user_name and last_name
    const formatName = (user) => {
        return `${user.user_name || ''} ${user.last_name || ''}`.trim();
    };

    return (
        <CardBody>
            <div className='card-body pt-0'>
                <div>
                    <Table borderless variant={`${darkMode ? "dark" : ""}`}>
                        <thead>
                            <tr>
                                <th><b>Name</b></th>
                                <th><b>Location</b></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="2" className="text-center">Loading...</td>
                                </tr>
                            ) : users.length > 0 ? (
                                users.map((user, index) => (
                                    <tr key={index}>
                                        <td>{formatName(user)}</td>
                                        <td>{user.city || 'N/A'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2" className="text-center">No active users found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
        </CardBody>
    );
}

export default ActiveParikamiTableCardBody;